import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import red from '@material-ui/core/colors/red';

const styles = {
  errorContainerStyle: {
    backgroundColor: red[500],
    textAlign: 'center',
    color: 'white',
  },
};

const ErrorMessage = ({ classes, errorMessage }) => {
  if (!errorMessage) {
    return null;
  }

  return (
    <div className={classes.errorContainerStyle}>
      <span>{errorMessage}</span>
    </div>
  );
};

ErrorMessage.propTypes = {
  classes: PropTypes.object.isRequired,
  errorMessage: PropTypes.string,
};

ErrorMessage.defaultProps = {
  errorMessage: null,
};

export default withStyles(styles)(ErrorMessage);
